import clsx from "clsx";

// Interfaces
import { ITextFieldExtension } from "./interfaces";

// MUI
import { InputAdornment, TextField, Typography } from "@mui/material";

export default function TextFieldExtension(props: Readonly<ITextFieldExtension>) {
	const {
		title = "",
		classes = "",
		placeholder = "",
		startAdornment = undefined,
		endAdornment = undefined,
		sx = undefined,
		inputProps = undefined,
		blink = false,
		name = "",
		type = "text",
		autoFocus = false,
		autoComplete = "off",
		disabled = false,
		editable = false,
		error = false,
		readOnly = false,
		related = false,
		border = false,
		warning = false,
		onChange = () => {},
		onClick = () => {},
		onBlur = () => {},
		onKeyDown = () => {},
		onFocus = () => {},
	} = props;

	return (
		<TextField
			inputProps={inputProps}
			InputProps={{
				startAdornment: startAdornment && (
					<InputAdornment position="start" sx={{ marginLeft: ".375rem", marginRight: "0rem" }}>
						<Typography className="!font-sans !text-default !text-[14.5px]">{startAdornment}</Typography>
					</InputAdornment>
				),
				endAdornment: endAdornment && (
					<InputAdornment position="start">
						<Typography className="!font-sans !text-default !text-[14.5px]">{endAdornment}</Typography>
					</InputAdornment>
				),
			}}
			autoFocus={autoFocus}
			name={name}
			type={type}
			fullWidth
			value={title}
			title={(startAdornment ?? "") + title + (endAdornment ?? "")}
			variant={related ? "outlined" : "standard"}
			placeholder={placeholder}
			autoComplete={autoComplete}
			spellCheck={"false"}
			className={clsx({
				[classes]: Boolean(classes),
				"simple-text-field": true,
				"simple-text-related": related,
				"simple-text-editable": editable,
				"regular-border": border,
				"blink-related": blink,
				"error-border": error,
				"warning-border": warning && !error,
				"simple-text-disabled": !editable || readOnly,
				"simple-text-grayed": readOnly,
			})}
			disabled={disabled || readOnly}
			sx={sx}
			onChange={onChange}
			onClick={onClick}
			onBlur={onBlur}
			onKeyDown={onKeyDown}
			onFocus={() => onFocus?.()}
		/>
	);
}
